export default (function (value) {
  return value === null || value === undefined;
});


//////////////////
// WEBPACK FOOTER
// ./~/redux-blueprint/~/redux-actions/es/utils/isNil.js
// module id = 691
// module chunks = 1